export default "__VITE_ASSET__DNNUNLAQ__"